import React from "react";
import { Sparkles } from "lucide-react";

import { data, pct, reais } from "../comum/formato";

// O relatório em linguagem simples, antes dos números.
export default function ResumoFrase({ periodo, r }) {
  if (!r) return null;
  if (!r.pedidos) {
    return <p className="rounded-xl border bg-card p-4 text-sm text-muted-foreground">Nenhum pedido usou cupom de {data(periodo.inicio)} a {data(periodo.fim)} com esses filtros.</p>;
  }
  return (
    <div className="rounded-xl border bg-gradient-to-r from-sky-500/10 to-transparent p-4 flex gap-3" data-e2e="resumo-cupons">
      <Sparkles className="w-5 h-5 text-sky-500 shrink-0 mt-0.5" />
      <p className="text-sm leading-relaxed">
        De <b>{data(periodo.inicio)}</b> a <b>{data(periodo.fim)}</b>, <b>{r.pedidos} pedido{r.pedidos === 1 ? "" : "s"}</b> {r.pedidos === 1 ? "usou" : "usaram"} cupom
        {r.pedidos_da_loja ? <> — {pct(r.pct_pedidos)} dos pedidos da loja</> : null}.{" "}
        <b>{reais(r.desconto)}</b> de desconto trouxeram <b>{reais(r.faturado)}</b> em vendas
        {r.retorno ? <>: cada R$ 1 de desconto virou <b>{reais(r.retorno)}</b></> : null}.{" "}
        {r.clientes_novos ? <><b>{r.clientes_novos} cliente{r.clientes_novos === 1 ? "" : "s"}</b> {r.clientes_novos === 1 ? "fez" : "fizeram"} o primeiro pedido com cupom. </> : null}
        O ticket médio com cupom foi <b>{reais(r.ticket_medio)}</b>{r.ticket_sem_cupom ? <>, contra {reais(r.ticket_sem_cupom)} sem cupom</> : null}.
        {r.lucro != null ? <> Lucro bruto de <b>{reais(r.lucro)}</b> ({pct(r.margem_pct)} de margem) nos pedidos com custo cadastrado.</> : null}
      </p>
    </div>
  );
}
